module.exports = __webpack_public_path__ + "img/img10.74367014.svg";